import type { ReviewMode } from '@/api/review'
import { copy } from '@/lib/copy'
import { cn } from '@/components/ui/cn'

const MODES: Array<{ value: ReviewMode; label: string }> = [
  { value: 'CLASSIC', label: copy.review.modeClassic },
  { value: 'REVERSE', label: copy.review.modeReverse },
  { value: 'FILL_BLANK', label: copy.review.modeFillBlank },
  { value: 'MULTIPLE_CHOICE', label: copy.review.modeMultipleChoice },
]

interface ReviewModeSelectorProps {
  value: ReviewMode
  onChange: (mode: ReviewMode) => void
  disabled?: boolean
}

export function ReviewModeSelector({ value, onChange, disabled }: ReviewModeSelectorProps) {
  return (
    <div
      className="grid grid-cols-2 gap-2 sm:flex sm:flex-wrap"
      data-testid="review-mode-selector"
    >
      {MODES.map((mode) => (
        <button
          key={mode.value}
          type="button"
          disabled={disabled}
          data-testid={`review-mode-${mode.value.toLowerCase()}`}
          onClick={() => onChange(mode.value)}
          className={cn(
            'min-h-11 rounded-full px-3 py-2 text-xs font-medium transition-colors sm:py-1.5 sm:text-sm',
            value === mode.value
              ? 'bg-primary text-primary-foreground'
              : 'bg-muted text-muted-foreground hover:bg-muted/80',
            disabled && 'pointer-events-none opacity-60',
          )}
        >
          {mode.label}
        </button>
      ))}
    </div>
  )
}
